export default "__VITE_ASSET__ls7PLDAP__"